/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Error_GenericInputs */



/**
* | output |
* | --- |
* | "Sync error occurred" |
*
* @param {Sync_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sync_error_generic = /** @type {((inputs?: Sync_Error_GenericInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Error_GenericInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur de synchronisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de sincronización")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Erro de sincronização")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore di sincronizzazione")
	return /** @type {LocalizedString} */ ("Sync error occurred")
});